module.exports = __webpack_public_path__ + "static/media/onboarding.3fad8bb6.jpg";